import React from "react";
import Text from "../../../common/typography/text";
import { formatNumber } from "../../../common/card";
import Divider from "../../../common/divider/divider";
import InsuranceStatusSelector from "../../../common/insurance-status-selector";
import Button from "../../../common/button/button";

const ConfirmationReview = ({
  productCodeData,
  priceTotal,
  shippingPreferenceCost,
  requiresPayment,
  activeTab,
  RENDER_PAYMENT_OPTIONS,
  processingFee,
  processingFeeLabel,
  shippingPreference,
  manufacturerName,
  productGroupName,
  placedByName,
  onCreateDirectOrder,
  isSubmitting,
  isLoadingAccountDetails,
  isPhone,
}) => {
  const hasSelectedProducts = (productCodeData || []).some(
    (product) => Number(product?.Quantity) > 0,
  );
  const disabledCheck =
    !hasSelectedProducts ||
    !shippingPreference ||
    isSubmitting ||
    isLoadingAccountDetails;

  const grandTotal = priceTotal + processingFee + shippingPreferenceCost;
  const isBankTransfer = activeTab?.key === "bank-transfer";
  const checkoutButtonLabel = isSubmitting
    ? requiresPayment
      ? "Redirecting..."
      : "Saving..."
    : requiresPayment
      ? "Continue To Checkout"
      : "Place Order";
  const helperText = !requiresPayment
    ? "Your order will be sent for approval"
    : isBankTransfer
      ? "Bank transfer selected. The total includes the bank processing fee."
      : "Card checkout selected. The total includes the card processing fee.";
  return (
    <>
      <Text variant="h1">Order Summary</Text>
      <div className="direct-order-review-detail-container">
        <div className="direct-order-review-detail-child-container">
          <div className="direct-order-review-detail-text-container">
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Placed By
              </Text>
            </div>
            <div className="direct-order-review-detail-content-text-container">
              <Text variant="bodyTextBold">{placedByName || "-"}</Text>
            </div>
          </div>
          <div className="direct-order-review-detail-text-container">
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Manufacturer
              </Text>
            </div>
            <div className="direct-order-review-detail-content-text-container">
              <Text variant="bodyTextBold">{manufacturerName || "-"}</Text>
            </div>
          </div>
          <div className="direct-order-review-detail-text-container">
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Product
              </Text>
            </div>
            <div className="direct-order-review-detail-content-text-container">
              <Text variant="bodyText">{productGroupName || "-"}</Text>
            </div>
          </div>
        </div>
      </div>
      {productCodeData.length > 0 && (
        <div className="direct-order-review-detail-container">
          {productCodeData?.map((product) => {
            return (
              <div className="direct-order-review-detail-child-container">
                <div
                  className="direct-order-review-child-content-container"
                  style={isPhone ? { flexDirection: "column" } : {}}
                >
                  <div className="direct-order-review-child-content-heading-container">
                    <div className="direct-order-review-detail-content-text-container">
                      <div
                        className="direct-order-review-detail-content-code-quality-container"
                        style={{ flexWrap: "wrap", alignItems: "baseline" }}
                      >
                        <Text variant="bodyText">
                          {product?.ProductName || "-"}
                        </Text>
                        {product?.ProductCode ? (
                          <Text variant="bodyTextBold">
                            {product.ProductCode}
                          </Text>
                        ) : null}
                      </div>
                    </div>
                    <div className="direct-order-review-detail-content-code-quality-container">
                      <Text variant="bodyText">
                        ${formatNumber(product?.Price).split(".")[0]}
                        <Text variant="bodyText">
                          .{formatNumber(product?.Price).split(".")[1]}
                        </Text>
                      </Text>
                      <Text variant="bodyText">x</Text>
                      <Text variant="bodyText">{product?.Quantity}</Text>
                    </div>
                  </div>
                  <Text variant="bodyTextBold">
                    $
                    {
                      formatNumber(
                        product?.Price * (product?.Quantity || 0),
                      ).split(".")[0]
                    }
                    <Text variant="bodyTextBold">
                      .
                      {
                        formatNumber(
                          product?.Price * (product?.Quantity || 0),
                        ).split(".")[1]
                      }
                    </Text>
                  </Text>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div className="direct-order-review-detail-container">
        <div className="direct-order-review-detail-child-container">
          <div
            className="direct-order-review-detail-text-container"
            style={{ width: "100%" }}
          >
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Subtotal
              </Text>
            </div>
            <div
              className="direct-order-review-detail-content-text-container"
              style={{ display: "flex", alignItems: "flex-end" }}
            >
              <Text variant="bodyText">
                ${formatNumber(priceTotal).split(".")[0]}
                <Text variant="bodyText" color="lightText">
                  .{formatNumber(priceTotal).split(".")[1]}
                </Text>
              </Text>
            </div>
          </div>
          <div
            className="direct-order-review-detail-text-container"
            style={{ width: "100%" }}
          >
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Shipping Cost
              </Text>
            </div>
            <div
              className="direct-order-review-detail-content-text-container"
              style={{ display: "flex", alignItems: "flex-end" }}
            >
              <Text variant="bodyText">
                ${formatNumber(shippingPreferenceCost).split(".")[0]}
                <Text variant="bodyText" color="lightText">
                  .{formatNumber(shippingPreferenceCost).split(".")[1]}
                </Text>
              </Text>
            </div>
          </div>
          {requiresPayment && processingFeeLabel ? (
            <div
              className="direct-order-review-detail-text-container"
              style={{ width: "100%" }}
            >
              <div className="direct-order-review-detail-title-text-container">
                <Text variant="bodyText" color="lightText">
                  {processingFeeLabel}
                </Text>
              </div>
              <div
                className="direct-order-review-detail-content-text-container"
                style={{ display: "flex", alignItems: "flex-end" }}
              >
                <Text variant="bodyText">
                  ${formatNumber(processingFee).split(".")[0]}
                  <Text variant="bodyText" color="lightText">
                    .{formatNumber(processingFee).split(".")[1]}
                  </Text>
                </Text>
              </div>
            </div>
          ) : null}
          <Divider />
          <div
            className="direct-order-review-detail-text-container"
            style={{ width: "100%" }}
          >
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyTextBold">Grand Total</Text>
            </div>
            <div
              className="direct-order-review-detail-content-text-container"
              style={{ display: "flex", alignItems: "flex-end" }}
            >
              <Text variant="bodyTextBold">
                ${formatNumber(grandTotal).split(".")[0]}
                <Text variant="bodyTextBold" color="lightText">
                  .{formatNumber(grandTotal).split(".")[1]}
                </Text>
              </Text>
            </div>
          </div>
        </div>
      </div>
      {requiresPayment ? (
        <InsuranceStatusSelector
          activeTab={activeTab}
          buttons={RENDER_PAYMENT_OPTIONS}
          parentClassname="full-width-button"
        />
      ) : null}
      <div className={`checkout-button-container full-width-button`}>
        <Button
          type="button"
          variant="blueButtonBig"
          className="full-width-button"
          disabled={disabledCheck}
          onClick={onCreateDirectOrder}
        >
          {checkoutButtonLabel}
        </Button>
        <Text variant="tinyText" color="lightText">
          {helperText}
        </Text>
      </div>
    </>
  );
};

export default ConfirmationReview;
